/* Terra Clava collection bands.
   Loads and plays only the band on screen; pauses the rest.
   The three source files are ~20MB each, so nothing preloads. */
(function () {
  function init() {
    var v = document.querySelectorAll('video[data-tc-band]');
    if (!v.length) return;
    var start = function (t) {
      if (!t.dataset.tcLoaded) {
        t.dataset.tcLoaded = '1';
        var s = document.createElement('source');
        s.src = t.dataset.tcSrc; s.type = 'video/mp4';
        t.appendChild(s); t.load();
      }
      var p = t.play(); if (p && p.catch) p.catch(function () {});
    };
    if (!('IntersectionObserver' in window)) { v.forEach(start); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { e.isIntersecting ? start(e.target) : e.target.pause(); });
    }, { rootMargin: '300px 0px', threshold: 0.01 });
    v.forEach(function (e) { io.observe(e); });
  }
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

  // sections re-rendered by the theme editor or the Section Rendering API get
  // fresh <video> nodes that the original observer never saw
  document.addEventListener('shopify:section:load', init);
})();
